import React from 'react';
import { useRecoilValue } from 'recoil';
import { ViewProduct } from '../models/ViewProduct.model';
import { isMobileState } from '../recoil/selectors';
import { Pills } from './Pills';

interface Props {
  product: ViewProduct;
  style?: React.CSSProperties;
}

export const ProductPerks: React.FC<Props> = ({ product, style }) => {
  const isMobile = useRecoilValue(isMobileState);
  const numPills = isMobile ? 2 : 3;

  return <Pills items={product.features.slice(0, numPills)} style={style} />;
};

export default ProductPerks;
